// Native
import { useState } from "react"
import { useParams } from "react-router"

// Style
import { ButtonGroup, Divider, Td, Tooltip, Tr } from "@chakra-ui/react"
import { Dev, IconButton, Profile, Searchable, Section, Stock, Table, Tag } from "components"

// Config
import { Moment } from "config"

// Hooks
import { useDistributor, useDistributorStockHistory } from "hooks"

export default function History(){

    const params = useParams()
    const distributor = useDistributor(params.id)
    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState('')
    const history = useDistributorStockHistory(distributor?.data?.id, page, term)

    const columns = [
        { children: 'Descrição' }, 
        { children: 'Produto' }, 
        { children: 'Anterior' }, 
        { children: 'Atual' }, 
        { children: 'Responsável' }, 
        { children: 'Data', isNumeric: true }
    ]

    return(
    <>
        <Section title="Histórico de alterações do estoque">
            <ButtonGroup size="xs" isDisabled={history.isFetching}>
                <IconButton label="Atualizar" icon="refresh" isLoading={history.isFetching} onClick={history.refetch} />
                <Dev data={history} />
            </ButtonGroup>
        </Section>

        <Divider />
        
        <Searchable placeholder="Procurar por descrição, código do pedido ou produto..." value={term} setValue={setTerm}  />

        <Table columns={columns} meta={history?.data?.meta} setPage={setPage} loading={history.isLoading}>
            {history?.data?.data?.map(item => <Item key={item.id} data={item} />)}
        </Table>
    
    </>
    )
}

const Item = ({ data:item, ...props }) => (
    <Tr {...props}>
        <Td maxW="200px" fontSize="xs" textOverflow="ellipsis" isTruncated><Tooltip label={item.label}>{item.label}</Tooltip></Td>
        <Td><Tag size="sm" children={item.product?.name ?? item.product_kit?.label} /></Td>
        <Td opacity={0.7}><Stock available={item?.history_data?.stock} reserved={item?.history_data?.reserved} /></Td>
        <Td><Stock available={item?.stock} reserved={item?.reserved} /></Td>
        <Td>{item?.employee ? <Profile name={item.employee.name} /> : 'Sistema'}</Td>
        <Td isNumeric children={Moment(item.created_at).calendar()} />
    </Tr>
)